import { render, staticRenderFns } from "./NavBarBfrLogin.vue?vue&type=template&id=263d89d1&scoped=true&"
import script from "./NavBarBfrLogin.vue?vue&type=script&lang=js&"
export * from "./NavBarBfrLogin.vue?vue&type=script&lang=js&"
import style0 from "./NavBarBfrLogin.vue?vue&type=style&index=0&id=263d89d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263d89d1",
  null
  
)

export default component.exports